<template>
  <ImportErrorAlert
    type="warning"
    :focus-on-mount="false"
    :title="$tc(`${I18N}.title`, rows.length)"
    :lines="lines"
  >
    <CopyToClipboardButton
      slot="actions"
      :text="tsv"
      :label="$t(`${I18N}.copy`)"
    />
  </ImportErrorAlert>
</template>

<script>
  import CopyToClipboardButton from '@/components/CopyToClipboardButton.vue';
  import ImportErrorAlert from './ImportErrorAlert.vue';
  import {
    countMalformedCodes,
    issueLines,
    malformedCodesToTsv,
  } from './labelIssues';

  // Rows left out because their sample code is malformed (C52, C53): reported,
  // never blocking, so no toast and no focus. Every cause with its fix, every
  // row to copy.
  export default {
    name: 'MalformedCodesAlert',
    components: { CopyToClipboardButton, ImportErrorAlert },
    props: {
      rows: { type: Array, required: true },
    },
    data() {
      return {
        I18N: 'analysesData.importValues.malformedCodes',
      };
    },
    computed: {
      lines() {
        return issueLines(countMalformedCodes(this.rows), this.translate);
      },
      tsv() {
        return malformedCodesToTsv(this.rows, this.translate);
      },
    },
    methods: {
      translate(key, values) {
        return this.$t(key, values);
      },
    },
  };
</script>
